import { useCallback, useEffect, useRef } from "react";

interface UseScrollEventsProps {
  onScrollDown?(): void;
  onScrollUp?(): void;
  treshold?: number;
}

export default function useScrollEvents({
  onScrollDown = () => {
    /* No-op */
  },
  onScrollUp = () => {
    /* No-op */
  },
  treshold = 50,
}: UseScrollEventsProps) {
  const lastScrollPos = useRef(0);

  const handleScroll = useCallback(() => {
    if (window.scrollY > lastScrollPos.current + treshold) {
      lastScrollPos.current = window.scrollY;
      onScrollDown();
    } else if (window.scrollY < lastScrollPos.current - treshold) {
      lastScrollPos.current = window.scrollY;
      onScrollUp();
    }
  }, [onScrollDown, onScrollUp, treshold]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return null;
}
